import { Card, CardContent, Typography } from "@mui/material";
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip } from "recharts";

const formatCurrency = (value, currency) =>
  `${currency}${Number(value / 100 || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

const formatNumber = (value) => Number(value || 0).toLocaleString();

const formatDate = (value) => {
  if (!value) return "";
  return new Date(value).toISOString().slice(0, 10);
};

export default function TrendChart({ title, data, dataKey, currency }) {
  const isValue = dataKey === "value";

  return (
    <Card sx={{ borderRadius: 3 }}>
      <CardContent>
        <Typography variant="h6" sx={{ mb: 2 }}>
          {title}
        </Typography>

        <ResponsiveContainer width="100%" height={260}>
          <LineChart data={data}>
            <XAxis dataKey="name" tick={false} axisLine={true} tickLine={false} />

            <YAxis
              tick={{ fontSize: 13 }}
              tickFormatter={(value) =>
                isValue ? `${currency}${Number(value / 100).toLocaleString()}` : formatNumber(value)
              }
            />

            <Tooltip
              contentStyle={{
                fontSize: 13,
                borderRadius: 8,
                padding: "8px 10px",
              }}
              labelStyle={{
                fontSize: 13,
                marginBottom: 4,
              }}
              itemStyle={{
                fontSize: 13,
              }}
              labelFormatter={(label) => formatDate(label)}
              formatter={(value) =>
                isValue ? formatCurrency(value, currency) : formatNumber(value)
              }
            />

            <Line type="monotone" dataKey={dataKey} stroke="#111827" strokeWidth={3} dot={false} />
          </LineChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
}
